export default __webpack_public_path__ + "static/media/23.9c38af5f.jpg";